module.exports = __webpack_public_path__ + "img/produce-2.d2214740.png";